export const setUrlParams = (url: string) => {
    if (typeof window !== 'undefined') {
        const mainUrlObj = new URL(url, window.location.origin)
        const mainUrlObjParams = new URLSearchParams(mainUrlObj.search)

        const pageUrlObj = new URL(window.location.href)
        const pageUrlObjParams = new URLSearchParams(pageUrlObj.search)

        pageUrlObjParams.forEach((value, key) => {
            if (!mainUrlObjParams.has(key)) {
                mainUrlObjParams.append(key, value)
            }
        })

        mainUrlObj.search = mainUrlObjParams.toString()
        return mainUrlObj.toString()
    }
    return url
}
